// src/views/Dropzone/Loading/Loading.tsx
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var Loading = ({ label }) => /* @__PURE__ */ jsxs(Flex, {
  direction: { base: "row", md: "column" },
  justifyContent: "center",
  alignItems: "center",
  pl: 6,
  children: [
    /* @__PURE__ */ jsx(Spinner, {
      variant: "contentMedium",
      mb: { base: 0, md: 6 },
      pointerEvents: "none",
      "data-testid": "spinner"
    }),
    /* @__PURE__ */ jsx(Text, {
      fontSize: "sm",
      color: "greyscale.600",
      mt: { base: 0, md: 6 },
      ml: { base: 5, md: 0 },
      children: label
    })
  ]
});

export {
  Loading
};
